/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query'
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query'
import { mutationOptionsWithInteraction } from '../../mutationOptions'
import { customInstance } from '../../mutator'
import type { HTTPValidationError, TaskResponseDTO } from '../fastAPI.schemas'

/**
 * Convert a Word project file to PDF (with refreshed table of contents)
in the worker. The PDF is saved as a new file next to the source file.
 * @summary Start Convert File To Pdf Task
 */
export const startConvertFileToPdfTask = (
  projectGuid: string,
  rootFolderGuid: string,
  fileGuid: string,
  signal?: AbortSignal,
) => {
  return customInstance<TaskResponseDTO>({
    url: `/projects/${projectGuid}/files/${rootFolderGuid}/file/${fileGuid}/pdf`,
    method: 'POST',
    signal,
  })
}

export const useStartConvertFileToPdfTaskMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startConvertFileToPdfTask>>,
    TError,
    { projectGuid: string; rootFolderGuid: string; fileGuid: string },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof startConvertFileToPdfTask>>,
  TError,
  { projectGuid: string; rootFolderGuid: string; fileGuid: string },
  TContext
> => {
  const mutationKey = ['startConvertFileToPdfTask']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startConvertFileToPdfTask>>,
    { projectGuid: string; rootFolderGuid: string; fileGuid: string }
  > = props => {
    const { projectGuid, rootFolderGuid, fileGuid } = props ?? {}

    return startConvertFileToPdfTask(projectGuid, rootFolderGuid, fileGuid)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/files/{rootFolderGuid}/file/{fileGuid}/pdf` },
    {
      operationId:
        'start_convert_file_to_pdf_task_projects__project_guid__files__root_folder_guid__file__file_guid__pdf_post',
      operationName: 'startConvertFileToPdfTask',
    },
  )

  return customOptions
}

export type StartConvertFileToPdfTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof startConvertFileToPdfTask>>
>

export type StartConvertFileToPdfTaskMutationError = HTTPValidationError

/**
 * @summary Start Convert File To Pdf Task
 */
export const useStartConvertFileToPdfTask = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startConvertFileToPdfTask>>,
    TError,
    { projectGuid: string; rootFolderGuid: string; fileGuid: string },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof startConvertFileToPdfTask>>,
  TError,
  { projectGuid: string; rootFolderGuid: string; fileGuid: string },
  TContext
> => {
  const mutationOptions = useStartConvertFileToPdfTaskMutationOptions(options)

  return useMutation(mutationOptions)
}
